import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import rentwareIcon from '../../../../types/icons';
import { SelectOption, SelectStyle } from '../../../../types/types';

@Component({
  tag: 'rentware-selection-list',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareSelectionList {
  @Event() valueChange: EventEmitter;
  @Prop() options: SelectOption[];
  @Prop() value: string;
  @Prop() selectStyle: SelectStyle = SelectStyle.Default;
  @Prop() onExpandedDidLoad: () => void;
  @Prop() customIconName: string;

  componentDidLoad() {
    this.onExpandedDidLoad();
  }

  handleOptionChange(e: Event, item: SelectOption) {
    e.preventDefault();
    this.valueChange.emit(item);
  }

  itemClass = (item: SelectOption): string => {
    const disabledCondition = item.disabled && !this.allOptionsAreDisabled;
    const disabled = disabledCondition ? ' DisabledItem' : '';
    return 'ListItem ' + 'ListItem' + this.selectStyle + disabled;
  };

  get labelPriceClass() {
    return 'ListItemPrice ListItemPrice' + this.selectStyle;
  }

  get allOptionsAreDisabled(): boolean {
    return this.options.every((item: SelectOption) => {
      return item.disabled;
    });
  }

  render() {
    return (
      <div class="Wrapper">
        {this.options?.map(item => {
          return (
            <div class={this.itemClass(item)} onClick={e => this.handleOptionChange.call(this, e, item)}>
              <RadioButton
                label={item.label}
                disabled={item.disabled}
                labelSecondRow={item.labelSecondRow}
                selectStyle={this.selectStyle}
                allOptionsAreDisabled={this.allOptionsAreDisabled}
                checked={item.value === this.value}
                onChange={e => this.handleOptionChange.call(this, e, item)}
                customIconSVG={rentwareIcon(item.customIconName || this.customIconName, item.customIconStyle)}
              />

              {!!item.labelPrice && <span class={this.labelPriceClass}>{item.labelPrice}</span>}
            </div>
          );
        })}
      </div>
    );
  }
}

const RadioButton = ({ label, labelSecondRow, allOptionsAreDisabled, selectStyle, checked, onChange, disabled, customIconSVG, ...rest }) => {
  const disabledCondition = disabled && !allOptionsAreDisabled;
  const classDisabled = disabledCondition ? ' DisabledItem' : '';
  const noIconStyle: boolean = selectStyle === SelectStyle.Simple || selectStyle === SelectStyle.Search || (selectStyle === SelectStyle.Config && !customIconSVG);
  const radioCLass = ((noIconStyle && 'LabelContainer LabelContainerSimple') || 'LabelContainer') + classDisabled;

  return (
    <label class={radioCLass} {...rest}>
      <input type="radio" checked={checked} name="radio" onChange={onChange} />

      {customIconSVG ||
        (!noIconStyle && (
          <svg class="LabelSVG" width="17" height="17" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect class="LabelSvgBg" x="0.5" y="0.879395" width="19" height="19" rx="9.5" />
            <path class="LabelSvgTic" d="M6 11.3794L8 13.3794L14 7.37939" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        ))}

      <div class="SelectRadioLabel">
        <span class="ListItemRow">{label}</span>

        {labelSecondRow && <span class="ListItemRow">{labelSecondRow}</span>}
      </div>
    </label>
  );
};
